const BREAKPOINT_DESKTOP_MIN = 769;

type TParams = {
  width: number;
  breakpointMin?: number;
};
export const isDesktop = ({
  width,
  breakpointMin = BREAKPOINT_DESKTOP_MIN,
}: TParams): boolean => {
  return width >= breakpointMin;
};
